import { motion } from 'framer-motion';
import { useCurrency } from 'hooks/useCurrency';
import { isSharEnabled } from 'lib/shar';

interface SharVoteBannerProps {
  sharAmount: number;
  secondsLeft: number;
  canVote: boolean;
  vote?: 'accept' | 'decline';
}

export default function SharVoteBanner({
  sharAmount,
  secondsLeft,
  canVote,
  vote,
}: SharVoteBannerProps) {
  const { format } = useCurrency();

  if (!isSharEnabled(sharAmount)) return null;

  const secs = Math.max(0, Math.ceil(secondsLeft));

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative z-40 mx-auto mt-1 max-w-[94vw] rounded-xl border border-tp-gold/35 bg-black/75 px-4 py-3 text-center backdrop-blur-md sm:mt-2 sm:px-6"
    >
      <p className="font-display text-sm font-bold text-tp-gold sm:text-base">
        Shar confirmation · {format(sharAmount)} each
      </p>
      <p className="mt-1 text-xs text-white/60">
        {canVote ? (
          <>
            Accept or decline within{' '}
            <span className="font-bold tabular-nums text-white">{secs}s</span> — all must accept
            for shar to apply
          </>
        ) : vote === 'accept' ? (
          <>You accepted — waiting for others ({secs}s left)</>
        ) : vote === 'decline' ? (
          <>You declined — waiting for others ({secs}s left)</>
        ) : (
          <>Vote in progress — {secs}s remaining</>
        )}
      </p>
      <p className="mt-1 text-[10px] uppercase tracking-wider text-white/40">
        No response before timer ends = auto decline
      </p>
    </motion.div>
  );
}
